import Cookies from 'js-cookie'
import Config from '@/api/config'
const TokenKey = 'Admin-Token'
const rootDomain = Config.rootDomain

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (rootDomain) {
    return Cookies.set(TokenKey, token, { domain: rootDomain })
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken() {
  if (rootDomain) {
    return Cookies.remove(TokenKey, { domain: rootDomain })
  } else {
    return Cookies.remove(TokenKey)
  }
}
/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(obj) {
  if (typeof obj !== "object" || obj == null) {
    return obj
  }
  let res
  if (obj instanceof Array) {
    res = []
  } else {
    res = {}
  }
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && (obj[key] || obj[key] === 0)) {
      res[key] = deepClone(obj[key])
    }
  }
  return res
}


// WEBPACK FOOTER //
// ./src/utils/index.js